export const selectDistributionOrganisation = {
    placeholder: "",
    allowClear: true,
    minimumResultsForSearch: -1
}